<template lang="pug">
    v-content
        .rtl
            v-layout(row py-2)
                v-flex.text-xs-left(md2)
                v-flex(xs12)
                    img(alt="Vue logo" style="margin: 0 auto; display: block; height: 130px;" src="@/assets/mendi_logo.jpg")
                v-flex.text-xs-left(md2)
                    v-btn(outline='', large='', fab='', color='indigo' @click="openFullscreen('.v-content__wrap')")
                        v-icon fullscreen
            v-layout(row wrap px-2)
                v-flex(md5 xs12 px-2)
                    v-text-field(v-model='searchText1' label='לקוח' append-icon='search' @keyup='search($event)')
                v-flex(md5 xs12 px-2)
                    v-text-field(v-model='searchText2' label='פריט' append-icon='search' @keyup='search($event)')
                v-flex(md2 xs12 pt-2)
                    v-layout(row wrap)
                        v-flex(xs6 pl-1)
                            //templete
                            v-btn(block @click='search()'  color="red lighten-1" dark )  חפש
                        v-flex(xs6 pr-1).-text-xs-left
                            //templete
                            v-btn(block @click='clean()'  color="blue-grey lighten-2" dark)  נקה

            v-flex(v-if="count")  נמצאו {{count}} תוצאות
        v-data-table#mendi-table.elevation-1(:headers='headers' :items='desserts' :loading='loading' hide-actions )
            v-progress-linear(slot='progress' color='blue' indeterminate='')
            template(slot='items' slot-scope='props')
                td.text-xs-right(:style="props.item.style.A" style="width: 5%; padding: 0px 5px; height: 30px;") {{ props.item.A }}
                td.text-xs-right(:style="props.item.style.B" style="width: 5%; padding: 0px 5px; height: 30px;") {{ props.item.B }}
                td.text-xs-right(:style="props.item.style.C" style="width: 20%; padding: 0px 5px; height: 30px;") {{ props.item.C }}
                td.text-xs-right(:style="props.item.style.D" style="width: 5%; padding: 0px 5px; height: 30px;") {{ props.item.D }}
                td.text-xs-right(:style="props.item.style.E" style="width: 55%; padding: 0px 5px; height: 30px;") {{ props.item.E }}
                td.text-xs-right(:style="props.item.style.F" style="width: 5%; padding: 0px 5px; height: 30px;") {{ props.item.F }}
                td.text-xs-right(:style="props.item.style.G" style="width: 5%; padding: 0px 5px; height: 30px;") {{ props.item.G }}


</template>

<script>
    export default {
        data () {
            return {
                loading : false,
                count : 0,
                searchText1: '',
                searchText2: '',
                headers: [
                    { text: 'סוג', value: 'A' },
                    { text: 'תעודה', value: 'B' },
                    { text: 'שם לקוח', value: 'C' },
                    { text: 'תאריך', value: 'D' },
                    { text: 'תיאור פריט', value: 'E' },
                    { text: 'כמות', value: 'F' },
                    { text: "מחיר יח'", value: 'G' }
                ],
                desserts: [

                ]
            }
        },
        created() {
          document.title = 'SearchTable';

            this.$socket.on('*', (packet) => {
                // log(packet)
                let channel = packet.data[0];
                let data = packet.data[1];
                let $uniqid = data.$uniqid;

                // log('packet',packet)
                if($uniqid) {
                    return this.$socket.res(data);
                }
                this.sockets(channel, data);
            });

            // log('this.$user', this.$user);
            this.$emit('update:loading', false);


            // this.searchText1 = 'מ';
            // this.search()
        },
        beforeRouteLeave(to, from, next) {
            this.$socket.off('*');
            this.$emit('update:loading', true);
            next();
        },


        methods : {
            openFullscreen(q) {
                var elem = document.querySelector(q);

                if (elem.requestFullscreen) {
                    elem.requestFullscreen();
                } else if (elem.mozRequestFullScreen) { /* Firefox */
                    elem.mozRequestFullScreen();
                } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
                    elem.webkitRequestFullscreen();
                } else if (elem.msRequestFullscreen) { /* IE/Edge */
                    elem.msRequestFullscreen();
                }
            },

            clean : function () {
                this.searchText1 = '';
                this.searchText2 = '';
            },
            search : function ($event) {
                // log('$event', $event)
                if(!$event || $event.code == 'Enter') {
                    this.loading = true;
                    this.$emit('update:loading', true);

                    this.$socket.req('mendi.search.get', {
                        search1 : this.searchText1,
                        search2 : this.searchText2,
                        user_id    : this.$user.id,
                    }).then(data => {
                        // log('data', data)

                        for(let idx in data.entities) {
                            for(let jdx in data.entities[idx]) {
                                data.entities[idx]['style'][jdx] = data.entities[idx]['style'][jdx] || {};
                            }
                        }

                        // log('data', data)
                        this.desserts =  [/*{
                        value: false,
                        A: 'תעודות חדשות בהכנה',
                    }*/].concat(data.entities);

                        this.count = data.entities.length;
                        this.loading = false;
                        this.$emit('update:loading', false);
                    });

                    setTimeout(()=> {
                        document.getElementsByClassName('v-table__overflow')[0].scrollLeft = 20000;
                    });

                }
            },
            sockets : function (channel, data) {
                let channels = {
                  'sum.channel' : (/*data*/) => {
                        // log('sum.channel', data)
                    }
                };
                if(!channels[channel]) {
                    return console.log('Socket channel not found:', channel);
                }

                return channels[channel](data);
            },
        }
    }



</script>


<style lang="sass">

    #mendi-table .v-table__overflow
        /*height: 300px;*/
        overflow-y: auto
        /*direction: rtl;*/


    #mendi-table .v-datatable.v-table
        direction: rtl


    .v-content__wrap
        background: #fff
    #mendi-table
        table.v-table tbody td:first-child, table.v-table tbody td:not(:first-child), table.v-table tbody th:first-child, table.v-table tbody th:not(:first-child), table.v-table thead td:first-child, table.v-table thead td:not(:first-child), table.v-table thead th:first-child, table.v-table thead th:not(:first-child)
            padding: 0 5px


</style>